export const machineTypeExcludeNames = [
    'f1-micro',
    'g1-small',
    'e2-micro',
    'e2-small',
    'e2-medium',
    'n1-standard-1'
];
